/* eslint-disable no-unused-vars */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return IRRendererAdapter;
    }
});
const _irrenderer = /*#__PURE__*/ _interop_require_default(require("@fluke/irrenderer"));
const _uuid = require("uuid");
const _is2uprerendereddata = require("@fluke/is2u-prerendered-data");
const _utilities = require("../../utilities");
const _coordinates = require("../lib/Transforms/coordinates.js");
const _enums = require("../lib/enums");
const _images = require("../../utilities/images");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
class IRRendererAdapter extends _irrenderer.default {
    async loadWASM(path = "") {
        await this.load_web_assembly_module(path, (classRef)=>{
            this.setIsReady(true);
        });
    }
    cleanup() {
        if (this) {
            // Free ir buffers using the ref rvalue
            this.irrenderer_release_pointers();
            if (this.is2Handle) {
                this.is2_close(this.is2Handle);
                this.is2Handle = null;
                this.photonotes = [];
            }
        }
    }
    setIsReady(nextBool = false) {
        this.isReady = nextBool;
        this.onReady(this.isReady);
    }
    unpack(buffer) {
        let unpacked = {};
        if (!this.isReady || !buffer) return unpacked;
        try {
            // unpack is2 file -->
            this.is2Handle = this.is2_open_buffer(buffer, true);
            let info = this.is2_get_metadata(this.is2Handle);
            let irdata = this.is2_get_irdata(this.is2Handle);
            let visual = this.is2_get_vldata(this.is2Handle);
            let preview = this.is2_get_thumbnail(this.is2Handle);
            this.getPhotonotes(this.is2Handle);
            unpacked = {
                info,
                preview,
                visual,
                irdata
            };
        } catch (e) {
            console.error("Error in unpacking IS2. -- ", e);
        }
        return unpacked;
    }
    async pack(info, preview) {
        if (!this.isReady || !this.is2Handle) return [];
        // create modified IS2 -->
        this.is2_set_metadata(this.is2Handle, JSON.stringify(info));
        this.is2_set_thumbnail(this.is2Handle, preview, "preview.jpg");
        this.is2_render(this.is2Handle, JSON.stringify(info));
        let is2 = this.is2_dump(this.is2Handle);
        // modified IS2 with prerenderedData -->
        try {
            // const copyIS2 = is2.slice();
            is2 = await (0, _is2uprerendereddata.updatePrerenderedData)(is2, this);
        } catch (e) {
            console.warn("Error in generating pre-rendered info. Skipping step --", e);
        }
        return is2;
    }
    loadBuffer(data) {
        if (!this.isReady) return;
        try {
            const { info, irdata, visual } = data;
            this.irrenderer_init_buffers(JSON.stringify(info), new Uint8Array(irdata), new Uint8Array(visual));
        } catch (error) {
            console.warn("Failed to load data buffers:", error);
        }
    }
    _updateCoordinateScaleOffset() {
        if (!this.isReady) return;
        // when the renderer updates, update the scale/offset values
        const { IR_RENDERER_SETTINGS: { Output_Image_IR: { Size: sizePIP }, Output_Image_VL: { Size: sizeVL }, Output_Temperatures_Celsius: { Size: sizeIR } } } = this.irrenderer_rendering_get_output_data();
        // is pip mode TRUE?
        const isPipEnabled = sizeVL.Width > sizePIP.Width; // ENABLED: VL > IR
        const { scale, offset } = (0, _coordinates.getScaleOffset)(// ir coordinate space -->
        sizeIR.Width, sizeIR.Height, // pip coordinate space -->
        sizePIP.Width, sizePIP.Height, // canvas coordinate space -->
        sizeVL.Width, sizeVL.Height, isPipEnabled);
        this.scaleOffset = {
            scale,
            offset
        };
    }
    run(info) {
        if (!this.isReady) return;
        try {
            this.is2_render(this.is2Handle, JSON.stringify(info));
            this._updateCoordinateScaleOffset();
        } catch (error) {
            console.error("Failed to render images:", error);
        }
    }
    getJSON() {
        if (!this.isReady) return;
        try {
            return this.irrenderer_rendering_get_output_data();
        } catch (error) {
            console.error("Failed to getJSON from image", error);
            return {};
        }
    }
    getImageVL() {
        if (!this.isReady) return;
        return this.irrenderer_get_rendered_image_vl();
    }
    getImageIR() {
        if (!this.isReady) return;
        return this.irrenderer_get_rendered_image_ir();
    }
    getPhotonotes(is2Handle) {
        if (!this.isReady || !this.is2Handle) return [];
        if (!is2Handle) {
            return this.photonotes;
        }
        // else get photonotes using current is2Handle
        try {
            let number_of_photonotes = this.is2_get_photonotes(this.is2Handle);
            const photonotes = Array(number_of_photonotes).fill(null);
            for(let i = 0; i < number_of_photonotes; i++){
                const photonoteBuffer = this.is2_get_photonote(i);
                // arraybuffer to jpeg
                photonotes[i] = (0, _images.arraybufferToImage)(photonoteBuffer, "jpeg");
            }
            this.photonotes = photonotes;
            return this.photonotes;
        } catch (e) {
            console.warn("Error in retrieving Photonotes --", e);
            return [];
        }
    }
    getPaletteData() {
        if (!this.isReady) return;
        return this.irrenderer_get_rendered_palette_range();
    }
    getPaletteSamples(width, height) {
        if (!this.isReady) return;
        return this.irrenderer_get_palette_samples(width, height);
    }
    getPaletteNames() {
        if (!this.isReady) return;
        return this.irrenderer_get_palette_names();
    }
    getPaletteAliasesMap() {
        if (!this.isReady) return;
        return this.irrenderer_get_palette_aliases_map();
    }
    getPalettePrettyNamesMap() {
        if (!this.isReady) return;
        return this.irrenderer_get_palette_pretty_names_map();
    }
    revealPaletteName(paletteName) {
        if (!this.isReady) return;
        return this.irrenderer_reveal_palette_name(paletteName);
    }
    getPaletteDisplayData() {
        let paletteDisplayData = {};
        if (this.isReady) {
            let gradients = {};
            Object.entries(this.getPaletteSamples(1, 64)).forEach(([key, value])=>{
                gradients[key] = (0, _utilities.colormap)(value);
            });
            paletteDisplayData = {
                paletteNames: this.paletteDeParalysis,
                paletteAliasesMap: this.getPaletteAliasesMap(),
                palettePrettyNamesMap: this.getPalettePrettyNamesMap(),
                paletteGradients: gradients
            };
        }
        return paletteDisplayData;
    }
    getPixelTemp(point = {}) {
        if (!this.isReady) return;
        // get output coordinates from renderer coordinates
        const outputPoint = (0, _coordinates.getCoordinates)(point, this.scaleOffset, true);
        // get temperature of output coordinate
        const pixelTemp = this.irrenderer_get_pixel_temp(outputPoint.x - this.scaleOffset.offset.x, outputPoint.y - this.scaleOffset.offset.y);
        return pixelTemp;
    }
    getMinMax(points = [], type = "") {
        // pass absolute canvas points
        let tempMin = +Infinity;
        let tempMax = -Infinity;
        let tempAvg = null;
        let tempSum = 0;
        let numPixels = 0;
        switch(type){
            case _enums.KonvaShapes.CIRCLE:
                tempMax = this.getPixelTemp(points[0]);
                break;
            case _enums.KonvaShapes.LINE:
                {
                    // interpolation
                    // https://stackoverflow.com/a/10317654
                    const res = 0.01;
                    for(let loc = 0; loc <= 1; loc += res){
                        const x = points[0].x * (1 - loc) + points[1].x * loc;
                        const y = points[0].y * (1 - loc) + points[1].y * loc;
                        const test = this.getPixelTemp({
                            x,
                            y
                        });
                        tempMin = Math.min(tempMin, test);
                        tempMax = Math.max(tempMax, test);
                        // sum for averaging
                        tempSum += test;
                        numPixels++;
                    }
                    tempAvg = Math.round(tempSum / numPixels);
                    break;
                }
            case _enums.KonvaShapes.ELLIPSE:
                {
                    // https://stackoverflow.com/a/41136531
                    const [UL, LR] = points;
                    const radiusX = Math.abs(LR.x - UL.x) / 2;
                    const radiusY = Math.abs(LR.y - UL.y) / 2;
                    const centerX = UL.x + radiusX;
                    const centerY = UL.y + radiusY;
                    const radiusXSquared = radiusX * radiusX;
                    // iterate over the y radius
                    for(let iy = -radiusY; iy <= radiusY; ++iy){
                        // calculate the horizontal distance from the center for the current y
                        const dx = Math.round(Math.sqrt(radiusXSquared - iy * iy));
                        // calculate the vertical position for the current y
                        const startY = centerY + iy;
                        // iterate over the x radius
                        for(let ix = -dx; ix <= dx; ++ix){
                            // calculate the horizontal position for the current x
                            const x = centerX + ix;
                            // get the pixel value at the current position
                            const pixelTemp = this.getPixelTemp({
                                x,
                                y: startY
                            });
                            // accumulate pixel values for averaging
                            tempSum += pixelTemp;
                            numPixels++;
                            // update current min and max pixel values
                            tempMin = Math.min(tempMin, pixelTemp);
                            tempMax = Math.max(tempMax, pixelTemp);
                        }
                    }
                    tempAvg = Math.round(tempSum / numPixels);
                    break;
                }
            case _enums.KonvaShapes.RECTANGLE:
            default:
                {
                    // box selection sort
                    const [UL, LR] = points;
                    for(let x = UL.x; x <= LR.x; x++){
                        for(let y = UL.y; y <= LR.y; y++){
                            // Fixed termination condition
                            const test = this.getPixelTemp({
                                x,
                                y
                            });
                            // sum for averaging
                            tempSum += test;
                            numPixels++;
                            // compute min/max
                            tempMin = Math.min(tempMin, test);
                            tempMax = Math.max(tempMax, test);
                        }
                    }
                    tempAvg = Math.round(tempSum / numPixels);
                    break;
                }
        }
        tempAvg = tempAvg || tempMax;
        return [
            tempMin,
            tempMax,
            tempAvg
        ];
    }
    getMarkerObject(canvasMarker = {}) {
        if (!this.isReady) return;
        let { type = "", label = "", name = "", id = "", points = [] } = canvasMarker;
        // zips marker-specific keys from renderer to the points array
        const getRendererCoordinates = (keys)=>keys.reduce((coords, key, index)=>{
                var _points_index, _points_index1;
                coords[key] = {
                    X: (_points_index = points[index]) === null || _points_index === void 0 ? void 0 : _points_index.x,
                    Y: (_points_index1 = points[index]) === null || _points_index1 === void 0 ? void 0 : _points_index1.y
                };
                return coords;
            }, {});
        let coordinates = {};
        switch(type){
            case _enums.KonvaShapes.CIRCLE:
                coordinates = getRendererCoordinates([
                    _enums.RendererCoordinates.POINT
                ], points);
                break;
            case _enums.KonvaShapes.LINE:
                coordinates = getRendererCoordinates([
                    _enums.RendererCoordinates.START,
                    _enums.RendererCoordinates.FINISH
                ], points);
                break;
            case _enums.KonvaShapes.RECTANGLE:
            case _enums.KonvaShapes.ELLIPSE:
                points = (0, _coordinates.getBoundingBox)(points);
                coordinates = getRendererCoordinates([
                    _enums.RendererCoordinates.UPPER_LEFT,
                    _enums.RendererCoordinates.LOWER_RIGHT
                ], points);
                break;
            default:
                break;
        }
        const [tempMin, tempMax, tempAvg] = this.getMinMax(points, type);
        return _object_spread_props(_object_spread({}, coordinates), {
            characteristics: {
                uniqueIDString: id || (0, _uuid.v4)(),
                markerLabel: label || "",
                markerName: name || "",
                // flags -->
                markerEnabledFlag: true,
                useImageEBT: true,
                // marker temperature -->
                markerTempC_Min: tempMin,
                markerTempC_Max: tempMax,
                markerTempC_Average: tempAvg
            }
        });
    }
    constructor(path = null, props = {}){
        super(path, (classRef)=>{
            this.setIsReady(true);
        });
        const { onReady = ()=>{} } = props;
        this.onReady = onReady;
        this.scaleOffset = {};
        this.is2Handle = null;
        this.photonotes = [];
        this.paletteDeParalysis = [
            "PALSCHEME_PHANTOM_VBW",
            "PALSCHEME_PHANTOM_BLRED",
            "PALSCHEME_HIGHCONTRAST",
            "PALSCHEME_PHANTOM_FIRE",
            "PALSCHEME_IRONBOW",
            "PALSCHEME_AMBER",
            "PALSCHEME_PHANTOM_VVARIO"
        ];
    }
}
